/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_With_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search for a colleague or type a name" |
*
* @param {Manual_Meeting_With_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_with_placeholder = /** @type {((inputs?: Manual_Meeting_With_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_With_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zoek een collega of typ een naam")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cherchez un collègue ou tapez un nom")
	return /** @type {LocalizedString} */ ("Search for a colleague or type a name")
});